export {
  GetAngleGrid,
  getNotCached,
  getIndicesNeededForeca,
  getIndicesNeeded,
  getLayer,
  getCurrentTime,
};

import { Point, doOverlap } from "@/utils/overlap";

// function pad(n) {
//   return n < 10 ? "0" + n : n;
// }

function getLayer(currentZoom, referenceZoom) {
  const layerMaxNum = 3; // 0 1 2 3
  var zoomProj = currentZoom - referenceZoom;
  if (zoomProj <= 0) {
    zoomProj = 0;
  } else if (zoomProj >= layerMaxNum) {
    zoomProj = layerMaxNum;
  }
  return layerMaxNum - zoomProj; // flip the index
}

// return indices needed for current zoom and map bounds
function getIndicesNeeded(this_p, zoomLevel, bnds) {
  console.log("=============== ", this_p.dataSource);
  console.log("this_p.ds[this_p.dataSource]", this_p.ds[this_p.dataSource]);
  //lats, lons, numOfTiles, latlon
  let numOfTiles =
    this_p.ds[this_p.dataSource].hWin[
    getLayer(zoomLevel, this_p.ref_zoom[this_p.dataSource])
    ];

  console.log("numOfTiles", numOfTiles);
  let northWest = bnds.getNorthWest();
  let southEast = bnds.getSouthEast();
  let latlon = [northWest.lng, northWest.lat, southEast.lng, southEast.lat];
  let lats = this_p.ds[this_p.dataSource].lats[String(numOfTiles)];
  let lons = this_p.ds[this_p.dataSource].lons[String(numOfTiles)];

  let VERBOSE_OUTPUT = false;
  let linIndices = [];

  if (VERBOSE_OUTPUT) {
    console.log(
      ":: getIndicesNeeded: [2.b.1]: getIndicesNeeded: GetTilesIndices: numOfTIles",
      numOfTiles
    );
    console.log(
      ":: getIndicesNeeded: [2.b.1]: getIndicesNeeded: GetTilesIndices: lats:",
      lats
    );
    console.log(
      ":: getIndicesNeeded: [2.b.2]: getIndicesNeeded: GetTilesIndices: lons:",
      lons
    );
  }

  let lat_map_min = latlon[3];
  let lat_map_max = latlon[1];
  let lon_map_min = latlon[0];
  let lon_map_max = latlon[2];
  // Check if some tiles left (typically they fall into the area completely)
  for (var i = 0; i < lats.length - 1; i++) {
    for (var j = 0; j < lons.length - 1; j++) {
      let tileLinIndex = numOfTiles * i + j;
      if (
        IsOverlapped(
          lats[i],
          lats[i + 1],
          lons[j],
          lons[j + 1],
          lat_map_min,
          lat_map_max,
          lon_map_min,
          lon_map_max
        )
      ) {
        linIndices.push(tileLinIndex);
      }
    }
  }

  return linIndices;
}

function IsOverlapped(
  r1_y_min,
  r1_y_max,
  r1_x_min,
  r1_x_max,
  r2_y_min,
  r2_y_max,
  r2_x_min,
  r2_x_max
) {
  var l1 = new Point(),
    r1 = new Point(),
    l2 = new Point(),
    r2 = new Point();
  l1.x = r1_x_min;
  l1.y = r1_y_max;
  r1.x = r1_x_max;
  r1.y = r1_y_min;

  l2.x = r2_x_min;
  l2.y = r2_y_max;
  r2.x = r2_x_max;
  r2.y = r2_y_min;

  let overlap = doOverlap(l1, r1, l2, r2);
  return overlap;
}

// GetAngleGrid returns the grid of angles for a given number of tiles
function GetAngleGrid(tilesNum, angle1, angle2) {
  var angleStep = (angle1 - angle2) / tilesNum;
  var angleStart = angle2;

  var angleGrid = [];

  for (var i = tilesNum; i >= 0; i--) {
    angleGrid.push(angleStart + angleStep * i);
  }
  return angleGrid;
}

// get indices absent in the cache
function getNotCached(this_p, indcs, zLayer, timeIdx) {
  let VERBOSE_OUTPUT = true;
  let notCached = [];
  if (VERBOSE_OUTPUT)
    console.log(
      ":: getNotCached: indcs, zLayer, timeIdx, this_p.dataSource:",
      indcs,
      zLayer,
      timeIdx,
      this_p.dataSource
    );

  for (let i = 0; i < indcs.length; i++) {
    let ds_st = false;
    if (this_p.dataSource == "nw") {
      ds_st = this_p.tiles[timeIdx][zLayer].has(indcs[i]);
    } else if (this_p.dataSource == "opera") {
      ds_st = this_p.tilesOpera[timeIdx][zLayer].has(indcs[i]);
    } else if (this_p.dataSource == "hr_de") {
      ds_st = this_p.tilesHRDE[timeIdx][zLayer].has(indcs[i]);
    } else if (this_p.dataSource == "hr_fr") {
      ds_st = this_p.tilesHRFR[timeIdx][zLayer].has(indcs[i]);
    } else if (this_p.dataSource == "hr_nl") {
      ds_st = this_p.tilesHRNL[timeIdx][zLayer].has(indcs[i]);
    } else if (this_p.dataSource == "hr_bi") {
      ds_st = this_p.tilesHRUK[timeIdx][zLayer].has(indcs[i]);
    } else if (this_p.dataSource == "hr_be") {
      ds_st = this_p.tilesHRBE[timeIdx][zLayer].has(indcs[i]);
    } else if (this_p.dataSource == "hr_sc") {
      ds_st = this_p.tilesHRSC[timeIdx][zLayer].has(indcs[i]);
    } else if (this_p.dataSource == "hr_ip") {
      ds_st = this_p.tilesHRES[timeIdx][zLayer].has(indcs[i]);
    } else if (this_p.dataSource == "foreca") {
      ds_st = this_p.tilesForeca[timeIdx][zLayer].has(indcs[i]);
    } else if (this_p.dataSource == "foreca_global") {
      ds_st = this_p.tilesForecaGlobal[timeIdx][zLayer].has(indcs[i]);
    }

    if (ds_st) {
      if (this_p.dataUpdateNeeded) {
        // udpate of the cache by means of the update event from the app
        if (VERBOSE_OUTPUT)
          console.log(
            ":: getNotCached: this_p.dataUpdateNeeded: ",
            this_p.dataUpdateNeeded
          );
        notCached.push(indcs[i]);
      } else {
        // update of the cache if the tile has old forecast timestamp
        if (this_p.dataSource == "nw") {
          if (VERBOSE_OUTPUT)
            console.log(
              "this_p.tiles[timeIdx][zLayer].get(indcs[i]).ForecastTime: ",
              this_p.tiles[timeIdx][zLayer].get(indcs[i]).forecastTime
            );
        } else if (this_p.dataSource == "opera") {
          if (VERBOSE_OUTPUT)
            console.log(
              "this_p.tilesOpera[timeIdx][zLayer].get(indcs[i]).ForecastTime: ",
              this_p.tilesOpera[timeIdx][zLayer].get(indcs[i]).forecastTime
            );
        } else if (this_p.dataSource == "hr_de") {
          if (VERBOSE_OUTPUT)
            console.log(
              "this_p.tilesHRDE[timeIdx][zLayer].get(indcs[i]).ForecastTime: ",
              this_p.tilesHRDE[timeIdx][zLayer].get(indcs[i]).forecastTime
            );
        } else if (this_p.dataSource == "hr_fr") {
          if (VERBOSE_OUTPUT)
            console.log(
              "this_p.tilesHRFR[timeIdx][zLayer].get(indcs[i]).ForecastTime: ",
              this_p.tilesHRFR[timeIdx][zLayer].get(indcs[i]).forecastTime
            );
        } else if (this_p.dataSource == "hr_nl") {
          if (VERBOSE_OUTPUT)
            console.log(
              "this_p.tilesHRNL[timeIdx][zLayer].get(indcs[i]).ForecastTime: ",
              this_p.tilesHRNL[timeIdx][zLayer].get(indcs[i]).forecastTime
            );
        } else if (this_p.dataSource == "hr_bi") {
          if (VERBOSE_OUTPUT)
            console.log(
              "this_p.tilesHRUK[timeIdx][zLayer].get(indcs[i]).ForecastTime: ",
              this_p.tilesHRUK[timeIdx][zLayer].get(indcs[i]).forecastTime
            );
        } else if (this_p.dataSource == "hr_be") {
          if (VERBOSE_OUTPUT)
            console.log(
              "this_p.tilesHRBE[timeIdx][zLayer].get(indcs[i]).ForecastTime: ",
              this_p.tilesHRBE[timeIdx][zLayer].get(indcs[i]).forecastTime
            );
        } else if (this_p.dataSource == "hr_sc") {
          if (VERBOSE_OUTPUT)
            console.log(
              "this_p.tilesHRSC[timeIdx][zLayer].get(indcs[i]).ForecastTime: ",
              this_p.tilesHRSC[timeIdx][zLayer].get(indcs[i]).forecastTime
            );
        } else if (this_p.dataSource == "hr_ip") {
          if (VERBOSE_OUTPUT)
            console.log(
              "this_p.tilesHRES[timeIdx][zLayer].get(indcs[i]).ForecastTime: ",
              this_p.tilesHRES[timeIdx][zLayer].get(indcs[i]).forecastTime
            );
        }
      }
    } else {
      notCached.push(indcs[i]);
    }
  }

  return notCached;
}

///////////////////////////////////////////
// Reprojects coordinates from EPSG:4326 to EPSG:3857
function reprojectCoordinates(lon, lat) {
  let x = (lon * Math.PI) / 180;
  let y = Math.log(Math.tan((lat * Math.PI) / 180 / 2 + Math.PI / 4));
  return { x, y };
}

// Transforms reprojected coordinates to 0 - 1 range
function transformCoordinates(x, y) {
  x = (1 + x / Math.PI) / 2;
  y = (1 - y / Math.PI) / 2;
  return { x, y };
}

// Calculates all tile indices for a given ROI and zoom level
function calculateTileIndices(
  upperLeftLon,
  upperLeftLat,
  lowerRightLon,
  lowerRightLat,
  zoom
) {
  let { x: ulX, y: ulY } = reprojectCoordinates(upperLeftLon, upperLeftLat);
  let { x: lrX, y: lrY } = reprojectCoordinates(lowerRightLon, lowerRightLat);

  ({ x: ulX, y: ulY } = transformCoordinates(ulX, ulY));
  ({ x: lrX, y: lrY } = transformCoordinates(lrX, lrY));

  const n = Math.pow(2, zoom);

  const ulTileX = Math.floor(ulX * n);
  const ulTileY = Math.floor(ulY * n);
  const lrTileX = Math.floor(lrX * n);
  const lrTileY = Math.floor(lrY * n);

  const tilesX = [];
  const tilesY = [];
  const tilesLin = [];

  const tilesMap = new Map();

  for (let x = ulTileX; x <= lrTileX; x++) {
    for (let y = ulTileY; y <= lrTileY; y++) {
      tilesX.push(x);
      tilesY.push(y);
      const linearIndex = calculateLinearIndex(x, y, zoom);
      tilesLin.push(linearIndex);
      tilesMap.set(linearIndex, { x, y });
    }
  }

  // return [tilesX, tilesY, tilesLin];
  return tilesMap;
}

function calculateLinearIndex(x, y, zoom) {
  return y * Math.pow(2, zoom) + x;
}

function getIndicesNeededForeca(zoomLevel, bnds) {
  let northWest = bnds.getNorthWest();
  let southEast = bnds.getSouthEast();

  console.log(
    "///////// Current boundaries are: ",
    bnds.getNorthWest(),
    bnds.getSouthEast()
  );

  // let idcsForecaX = [];
  // let idcsForecaY = [];
  // let idcsForecaLin = [];

  // let indcs = getIndicesNeeded(this_p, zoomLevel, bnds);
  // [idcsForecaX, idcsForecaY, idcsForecaLin] = calculateTileIndices(
  let tilesMapIdcs = calculateTileIndices(
    northWest.lng,
    northWest.lat,
    southEast.lng,
    southEast.lat,
    zoomLevel
  );

  // return [idcsForecaX, idcsForecaY, idcsForecaLin];
  return tilesMapIdcs;
}

// function flatten(arr) {
//   return arr.reduce(function (flat, toFlatten) {
//     return flat.concat(
//       Array.isArray(toFlatten) ? flatten(toFlatten) : toFlatten
//     );
//   }, []);
// }

function getCurrentTime() {
  var today = new Date();
  var date =
    today.getFullYear() + "-" + (today.getMonth() + 1) + "-" + today.getDate();
  var time =
    today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
  var dateTime = date + " " + time;
  return dateTime;
}
